export const localImageMap = {
  'chocolate-box-silver.jpg': require('../assets/chocolate-box-silver.jpg'),
  'chocolate-box-gold.jpg': require('../assets/chocolate-box-gold.jpg'),
  'banner-renew.png': require('../assets/banner-renew.png'),
  'banner-1-1-calls.png': require('../assets/banner-1-1-calls.png'),
  'banner-delivery.png': require('../assets/banner-delivery.png'),
  'sushi.jpg': require('../assets/sushi.jpg'),
};
